// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ZjG0","location":"Header_location__3eRHg"};